// 日文全局化配置, 多端分校共用
// global目录中文件配置与多端分校目录配置文件名保持一致
// 多端分校目录配置规则优先级大于global目录中配置
import { requireFiles } from 'common/utils'

export default requireFiles(require.context('./', true, /\.js$/))
